import { createContext, useContext, useState } from 'react';
import { useWithSound } from '../hooks/useWithSound';
import notificationSound from '../assetts/sounds/notificationSound.mp3'

const SoundContext = createContext(null);

export function SoundProvider({ children }) {
    const { playSound, pauseSound, ready } = useWithSound(notificationSound);
    const [muted, setMuted] = useState(
        () => localStorage.getItem('notif-muted') === 'true'
    );
    const handlePlaySound = () => {
        if (muted) return;
        playSound();
    };

    const toggleMute = () => {
        const next = !muted;
        setMuted(next);
        localStorage.setItem('notif-muted', String(next));
    };

    return (
        <SoundContext.Provider value={{ playSound: handlePlaySound, pauseSound, ready, muted, toggleMute }}>
            {children}
        </SoundContext.Provider>
    );
}

export const useSound = () => {
    const ctx = useContext(SoundContext);
    if (!ctx) throw new Error('useSound must be used inside <SoundProvider>');
    return ctx;
};